import React from "react";
import Sidebar from "react-sidebar";

class QuizSideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: true,
      list: []
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  onSetSidebarOpen(open) {
    this.props.onSetSidebarOpen(open);
    // this.setState({ sidebarOpen: open });
  }

  componentDidUpdate(prevProps, prevState) {
    console.log(this.props.list);
    if (prevProps.list !== this.props.list) {
      console.log(prevProps.list);
      console.log(this.props.list);
      this.setState({ list: this.props.list, question: this.props.question });
    }
  }

  changeQuestion = id => {
    this.props.changeQuestion(id);
    this.props.onSetSidebarOpen(false);
  };

  render() {
    return (
      <Sidebar
        sidebar={
          <div className="new-quiz sidebar-nav">
            <h3>{this.props.question}</h3>
            <ul className="list-group">
              {this.props.list.map((question, key) => (
                <li
                  className={`list-group-item question-item ${
                    this.props.count == key ? "selected" : ""
                  }`}
                  id={key}
                  onClick={this.changeQuestion.bind(this, key)}
                >
                  <div className="row">
                    <div className="col-9"> Question {key + 1}</div>
                    <div className="col-3">
                      {localStorage.getItem("quiz")
                        ? JSON.parse(localStorage.getItem("quiz")).map(quiz => (
                            <span>
                              {question.question_id == quiz.question_id ? (
                                quiz.obtained_score == quiz.total_score ? (
                                  <i className="fas fa-check-circle text-success"></i>
                                ) : (
                                  <i className="fas fa-times-circle text-danger"></i>
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          ))
                        : ""}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        }
        open={this.props.sidebarOpen}
        onSetOpen={this.onSetSidebarOpen}
        styles={{ sidebar: { background: "white", width: "200px" } }}
      ></Sidebar>
    );
  }
}

export default QuizSideBar;
